export const LINK_TO_FETCH_MY_PROFILE = 'https://api.spotify.com/v1/me';
export const LINK_TO_FETCH_MY_TRACKS = 'https://api.spotify.com/v1/me/tracks';
export const LINK_TO_FETCH_MY_PLAYLISTS = 'https://api.spotify.com/v1/me/playlists';
export const LINK_TO_SEARCH = 'https://api.spotify.com/v1/search?q=';
